import createStore from '../../../redux/factories/crud/crudFactory';
import scanReducers from './reducers';

const {actionTypes, actions, reducers, sagas} = createStore('ocr-service/api/v2/scan');

export {actionTypes, actions, reducers, sagas, scanReducers};
